import { useEffect, useRef } from "react";

type UseScrollFetchParams = {
  fetch: () => Promise<unknown>;
  hasNext?: boolean;
  isFetching: boolean;
};

export const useScrollFetchRef = ({
  fetch,
  hasNext,
  isFetching,
}: UseScrollFetchParams) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hasNext) {
      return;
    }

    const observer = new IntersectionObserver(async (entries) => {
      const entry = entries[0];

      if (entry.isIntersecting && hasNext && !isFetching) {
        await fetch();
      }
    });

    const currentLoadMoreRef = ref.current;

    if (currentLoadMoreRef) {
      observer.observe(currentLoadMoreRef);
    }

    return () => {
      if (currentLoadMoreRef) {
        observer.unobserve(currentLoadMoreRef);
      }
    };
  }, [fetch, hasNext, isFetching]);

  return ref;
};
